import script from "./AllActions.vue?vue&type=script&setup=true&lang=js"
export * from "./AllActions.vue?vue&type=script&setup=true&lang=js"

import "./AllActions.vue?vue&type=style&index=0&id=18ad7113&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18ad7113"]])

export default __exports__